import { Component, OnInit, EventEmitter, Output ,Pipe, PipeTransform, ViewChild, ElementRef, TemplateRef} from '@angular/core';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription, Observable } from 'rxjs';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { GetDocumentDetails } from 'src/app/viewModels/core/delete-document-req-vm';
import { DomSanitizer, SafeUrl, SafeResourceUrl  } from '@angular/platform-browser';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { COMMA, ENTER, F } from '@angular/cdk/keycodes';
import { map, startWith } from 'rxjs/operators';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CoreService } from '../../core/services/coreService/core.service';
import { AddTouchesComponent } from 'src/app/middleware/common/addtouches/addtouches.component';
import {FileManagerService} from '../services/fileManager.services';
import { environment } from 'src/environments/environment';
import { ModuleName } from '../services/fileManager.enum';
import heic2any from "heic2any";
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { escape } from 'querystring';
declare var require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})

export class DocumentViewerComponent implements OnInit {
  @Input() folderID :number=0;
  @Input() docData :any;  
  documentdetails= new GetDocumentDetails();
  viewer = 'google';
  organizationId: string;
  databaseId: string;
  currentUser: any;
  selectedImagetoShow: any;
  showDetail:boolean = false;
  CloseViewDocument:boolean = false;
  addNote:boolean = false;
  
  clickEventsubscription: Subscription;
  
  documentModel = {
    userID: '',
    documentID:0,  
    databaseID: 0,
    organizationID: 0,
    type:0
  };
  updatedocumentModel = {
    userID: '',
    documentID:0,  
    databaseID: 0,
    organizationID: 0,
    description: '',
    tagIdList:[],
    newTags:'',
    type:0,
    placeholderID:0
  };

  newTagsValues: string;

  responseHolder: any;
  myFormGroupDetails: FormGroup; 
  documentId:number;
  DocumentShow:boolean;
  documentData:any;
  tagCtrl = new FormControl();
  filteredTags: Observable<string[]>;

  newtag: string[] = [];
  tags: string[] = [];
  allTags: string[] = [];
  AllTagList: any;
  selectedtagsId: any = [];

  newtags:string[]=[];
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA]; 
  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  
  @Output() getCloseDocumentViewer = new EventEmitter<boolean>();

  getTagListResponseHolder: any;
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,    
    PageSize:0,
    OfficeIDList:[]
  };
  documentType: any;
  fileSize: string="";
  documentName: string="";
  createdOn:any;
  myTouchesForm: FormGroup;
  TouchesType :any[]=[];
  AllContactTouchesList  :any[]=[];
  folderList: any[] = [];
  modulename:string;
  folderId:number=0;
  transactionID: string;

  AllCoreTouchesList  :any[]=[];
  documentID :number;
  documentpath: SafeResourceUrl;
  showLocalPanel: boolean = false;
  OfficeIDList: any=[];
  myOfficeID: any;
  uploadedBy:string="";
  uploadedByEmail:string="";
  fileManagerItemID:number=0;
  fileFoldeTypeId:number=2;

  constructor(private coreService: CoreService, private dialog: MatDialog, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private _dataSharingService: DataSharingService,
    private statusConst: StatusConstant, public sanitizer: DomSanitizer, private formBuilder: FormBuilder,
    private toastr: ToastrService, private settingsService: SettingService,private fileManagerService:FileManagerService,private loaderService: LoaderService) { 
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);
    this.currentUser = jwt_decode(token);
    this.documentdetails= new GetDocumentDetails();
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
    this.filteredTags = this.tagCtrl.valueChanges.pipe(startWith(null), map((fruit: string | null) => fruit ? this._filter(fruit) : this.allTags.slice()));
  }

  // ngOnDestroy() {
  //   this.clickEventsubscription.unsubscribe();      
  // }

  ngOnInit(): void {
    if(environment.production) {      
      this.showLocalPanel=false;
    }else{     
      this.showLocalPanel=true;
    }
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    this.coreFieldSaveCompareForType = [];
    this.coreFieldListForType=[];
    this.dynamicArray = [];
    this.dynamicArrayPhone = [];
    this.dynamicArrayAddress = [];
    this.dynamicArrayWebsite = [];      
    let group = {};
    this.myFormGroup = new FormGroup(group);    

    this.DocumentShow=false;
    this.folderID;
    this.docData;    
    this.documentName="";
    this.documentType="";
    this.fileSize="";
    this.createdOn="";
    this.documentpath="";
    this.modulename = ModuleName.FileManager;
    this.documentdetails = new GetDocumentDetails();
    this.documentID = this.docData[0].documentID;
    this.fileManagerItemID= this.docData[0].documentID;
    this.TypeIdDrp = this.docData[0].documentTypeID;
    this.getAllTagsList1("")   
    this.GetFileFields();    
    // this.clickEventsubscription = this._dataSharingService.getSelectedDocumentForFileManager().subscribe((result) => {
    //   if (result!=null) {   
    //     this.documentName="";
    //     this.documentType="";
    //     this.fileSize="";
    //     this.createdOn="";
    //     this.documentpath="";
    //     this.documentdetails = new GetDocumentDetails();
    //     this.documentID = Object.values(result)[0];       
    //     this.modulename = "FileManager";      
    //     this.getDocumentDetails(result);
    //   }      
    // });        
    this.createForm();
  }

  b64toBlob(b64Data, contentType='', sliceSize=512){
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

   blobToBase64 = blob => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };

  getHEICFile(fileName:any,url:any) {
    this.fileManagerService.getAttachment(fileName,url).subscribe((response) => {
      if (response !== undefined) {
        const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
        let blobfile=this.b64toBlob(response.data.base64URL,response.data.contentType);
       (heic2any({
            blob:blobfile,
            toType:"image/jpeg",
            quality: 0.5
          })).then((conversionResult) => {
              this.blobToBase64(conversionResult).then(res => {              
                this.loaderService.hide();
                this.selectedImagetoShow=res;
              });
            });
      }else{
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }

  getDocumentDetails(result) {
    this.loaderService.show();
    this.documentpath="";
    //this.documentpath= (result.documentPath);
    this.documentModel.userID = this.currentUser.UID;
    this.documentModel.documentID = result[0].documentID;
    this.documentModel.databaseID = Number(this.databaseId);
    this.documentModel.organizationID = Number(this.organizationId);
    this.documentModel.type =1; // 1 FOR OCRE, 2 FOR CONTACT, 3 COMPANY     
    this.documentData=null;
     let reqModel = {
      fileManagerItemID:this.documentID,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      officeID:this.myOfficeID,
    }    
    this.fileManagerService.GetFileManagerFileDetail(reqModel).subscribe((response) => {
        if (response != undefined) {         
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.documentdetails = response.data;           
            this.documentId =  response.data.fileManagerItemID;           
            if(response.data.fileType!=undefined){
              this.documentType = response.data.fileType;
            }
            if(response.data.fileType==undefined){
              this.documentType = response.data.name.split('.').pop();
            }
            if(response.data.fileSize!=null || response.data.fileSize!=undefined){
              this.fileSize = this.getReadableFileSizeString(response.data.fileSize);
              if(this.fileSize==undefined){
                this.fileSize =this.documentdetails.fileSize;
              }
              if(this.fileSize=="NaN kB" || this.fileSize=="NaN KB"){
                this.fileSize =this.documentdetails.fileSize;
              }
            }
           
            this.documentName =response.data.name;
            this.createdOn =result.createdOn;
            if(this.createdOn==undefined){
              this.createdOn =this.documentdetails.createdOn;
            }
            var path = response.data.azureblobPath;
            var path2 = path.replace(/\\/g, "/");
            if(response.data.azureblobPath.indexOf("https://")>=0){
            this.documentpath = response.data.azureblobPath;
            }
            if(this.documentType!='' && this.documentType!=undefined)
              {
                this.documentType=this.documentType.toLowerCase();
              }
              if(this.documentType=='heic')
              {
                this.getHEICFile(this.documentName,this.documentpath);
              }
              else
              {
                this.loaderService.hide();
              }
        if(response.data.documentData!=null)
        {
          this.documentData= JSON.parse(response.data.documentData);
        }
            if(response.data.uploadedByEmail==null){
              var firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,response.data.uploadByFirstName);
              var lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,response.data.uploadByLastName);
              this.uploadedBy =firstName+" "+lastName;
            }
            if(response.data.uploadedByEmail!=null){
              this.uploadedBy =response.data.uploadedByEmail;
            }

            if (response.data.tagLists.length > 0 && response.data.tagLists.length != undefined) {
              this.tags = [];             
              var drpId = response.data.tagLists;//.split(',');    
              for (let i = 0; i < drpId.length; i++) {
                var id = drpId[i];
                var value = this.AllTagList.filter((s) => s.tagID == parseInt(id));
                this.tags.push(value[0].tagName);
              }
            }
            else {
              this.tags = [];
            }  
          //   if(result.fileManagerInboxID==undefined){
          //   var path = response.data.azureblobPath;
          //   var path2 = path.replace(/\\/g, "/");
          //   if(response.data.azureblobPath.indexOf("https://")>=0){
          //   this.documentpath = response.data.azureblobPath;
          //   }
          //   else{
          //   this.documentpath = "https://ecmstorageaccount.blob.core.windows.net/ecmfilemanager/"+ path2;
          //   }
          // }else{
          //   this.documentpath = result[0].documentPath;
          //  }                                             
          }
        } else {
        }
      });
  }

  add1(event: MatChipInputEvent): void {
    this.myFormGroupDetails.markAsDirty();	
    this.myFormGroupDetails.markAsTouched();

    const input = event.input;
    const value = event.value.toLowerCase();
 
    // Add our tag
    if ((value || '').trim()) {
      this.newtag.push(event.value.trim());
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());

      if (index >= 0) {
        //this.tags.splice(index, 1);
      }
      else {
        this.tags.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.tagCtrl.setValue(null);
  }

  remove1(tag: string): void {
    const index = this.tags.indexOf(tag);
    if (index >= 0) {
      this.tags.splice(index, 1);

      if (this.tags.length > 0) {
        this.selectedtagsId = [];
        var fieldListdrp = [];
        var value;
        for (let i = 0; i < this.tags.length; i++) {
          var drpValue = this.tags[i];
          var value = this.AllTagList.filter((s) => s.tagName == drpValue);
          var newValue = value[0].tagID;

          var tagId = {
            tagID: newValue,            
          };
          fieldListdrp.push(tagId);
        }
        this.selectedtagsId = fieldListdrp;
      } 
      if (this.tags.length == 0) {
        this.selectedtagsId = this.tags;
      }          
    }
  }

  selected1(event: MatAutocompleteSelectedEvent): void {
    this.myFormGroupDetails.markAsDirty();	
    this.myFormGroupDetails.markAsTouched();
    const index = this.tags.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.tagInput.nativeElement.value = '';
    }
    else {
      this.tags.push(event.option.viewValue);
      this.tagInput.nativeElement.value = '';
      this.tagCtrl.setValue(null);

      if (this.tags.length > 0) {
        this.selectedtagsId = [];
        var fieldListdrp = [];
        var value;
        for (let i = 0; i < this.tags.length; i++) {
          var drpValue = this.tags[i];
          var value = this.AllTagList.filter((s) => s.tagName == drpValue);
          var newValue = value[0].tagID;

          var tagId = {
            tagID: newValue,            
          };
          fieldListdrp.push(tagId);
        }
        this.selectedtagsId = fieldListdrp;
      }     
    }
  }


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(tag => tag.toLowerCase().indexOf(filterValue) === 0);
  }

  createForm() {
    this.myFormGroupDetails = this.formBuilder.group({
      description: ['',]     
    });
  }

  // get Tag List
  getAllTagsList1(result) {
    this.allTags=[];
    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';    
    this.getTagListModel.PageSize = 0;
    this.getTagListModel.OfficeIDList=this.OfficeIDList
    this.settingsService.getAllTagsList(this.getTagListModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
          this.AllTagList = this.getTagListResponseHolder.data.tagListWithId;          
          if (this.AllTagList.length > 0) {
            for (let i = 0; i < this.AllTagList.length; i++) {
              var value = this.AllTagList[i].tagName;
              this.allTags.push(value);
            }           
          }    
          this.getDocumentDetails(this.docData);   
        }else {     
          this.getDocumentDetails(this.docData);   
        }
      }else{
        this.getDocumentDetails(this.docData);
      }
    });
  }


  getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes).toFixed(3) + byteUnits[i];
  };
 
  
  async UpdateDocumentDetails() {
    this.spinner=true;
    this.myFormGroup.markAsPristine();
    this.selectedtagsId=[];
    for (let i = 0; i < this.tags.length; i++) {
      var value = this.AllTagList.filter((s) => s.tagName == this.tags[i]);
      if(value.length>0)
        this.selectedtagsId.push({
          tagID: value[0].tagID           
        });
    }     
    this.updatedocumentModel.placeholderID = 0;
    this.updatedocumentModel.documentID = this.documentID;//this.documentId;
    this.updatedocumentModel.userID = this.currentUser.UID;
    this.updatedocumentModel.description = this.documentdetails.description;    
    this.updatedocumentModel.databaseID = Number(this.databaseId);
    this.updatedocumentModel.organizationID = Number(this.organizationId);
    this.updatedocumentModel.tagIdList=this.selectedtagsId;
    this.updatedocumentModel.type=5 ; //1 for file manager
    if (this.newtag.length > 0){
      this.updatedocumentModel.newTags = this.newtag.join(',');//this.tags;
    }
    else{
      this.updatedocumentModel.newTags = "";
    }   
    const result = await this.fileManagerService.UpdateDocumentsDetailByDocumentId(this.updatedocumentModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {    
      this.spinner=false;
      // this.toastr.success("Document update successfully.", '', {
      //   timeOut: 3000,
      // });
      this.newtag=[];
      this.CloseDocumentViewer(false);      
    }
    else {
      this.newtag=[];
      this.spinner=false;
      this.CloseDocumentViewer(false);      
    }    
  }

  opendocdetail() {
    this.showDetail = !this.showDetail
  }

  CloseDocumentViewer(message:boolean){
    this.myFormGroupDetails.reset();    
    this.documentpath=null;
    this.getCloseDocumentViewer.emit(message);
    //this._dataSharingService.sendSelectedDocumentForFileManager(null);
  }

 
  
  // get touch type ==//
 getTouchTypeList() {
  var ReqModel={
    databaseId:Number(this.databaseId),
    organizationID:Number(this.organizationId),
    OfficeIDList:this.OfficeIDList
   }
   this.settingsService.getAllTouchTypeList(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.getTagListResponseHolder = response;
       if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
         this.TouchesType = this.getTagListResponseHolder.data;
       }
       else {
       }
     }
   });
 }

 menuModulesList:any=[]=[];
 folderIdForFileManager:number=0;

 // get Activity List
 getAllTouchesList() {
  this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedFileManager = [];   

    SelectedFileManager = this.menuModulesList.filter(x => x.mainModuleName == 'File Manager');
    if (SelectedFileManager.length > 0) {
      this.folderIdForFileManager=SelectedFileManager[0].folderID;      
    }
   var ReqModel={
    folderID:1,//this.folderIdForFileManager,    
    databaseID:Number(this.databaseId),
    organizationID:Number(this.organizationId),   
    //transactionID:0,
    //placeholderID:0,
    documentID:this.documentID,
    //itemType:typeId,
    //touchesType:0,    
    officeID:this.myOfficeID,
    userID:this.currentUser.UID      
  }
   this.fileManagerService.GetAllFileManagerTouches(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
        this.getTagListResponseHolder = response.data;
        if(this.getTagListResponseHolder !=null){
          this.getTagListResponseHolder.map((res) => {
            if (res.createdByLastName != null) {
              res.createdByFirstName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey, res.createdByFirstName);
            }
            if (res.createdByLastName != null) {
              res.createdByLastName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey,res.createdByLastName
              );
            }
            return res;
          });  
        }         
        this.AllCoreTouchesList = this.getTagListResponseHolder;//.data;                 
      }
      else {
      }
    }
  });
}
tabType:number=0;

onTabClick(event) {
  this.tabType=event.index; 
  if(event.tab.textLabel=="ACTIVITY"){
    this.AllCoreTouchesList=[];
    this.getAllTouchesList();
  }  
   
}

 
 addTouch() {
  const dialogRef = this.dialog.open(AddTouchesComponent, {     
    data: {
      moduleName:"File Manager",
      folderID:1,//this.folderId, {{Main=1;Item=2;}}
      documentID: this.documentID,
      cType:5 // File Manager      
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result!=null && result!=undefined){
      this.getAllTouchesList();
    }    
  });
 }
  
  close() {   
    this.dialog.closeAll();
  } 
  
  DownloadFile() {
    this.loaderService.show();
    var ReqModel = {
      transactionID: Number(sessionStorage.getItem("transactionID")),
      fileManagerItemID: this.documentModel.documentID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.fileManagerService.DownloadDocument(ReqModel).subscribe((response) => {
      if (response != undefined && response.base64URL != null && response.base64URL != undefined) {
        const data = 'data:' + response.contentType + ';base64,' + response.base64URL;
        FileSaver.saveAs(data, response.name);
        this.loaderService.hide();
      } else {
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }
    });
  }













  coreFieldSaveCompareForType: any[];
  coreFieldListForType: any[];
  myFormGroup: FormGroup;
  transactionUserName: any;
  transactionUserRole: any;
  addressFormGroup: any=[];
  dynamicArray: any;
  dynamicArrayPhone: any;
  dynamicArrayAddress: any;
  dynamicArrayWebsite: any;

  addressValue:any;
  cityValue: any;
  stateValue: any;
  zipValue: any;
  grpToggle: boolean = true;
  checkboxStatus: boolean = false;
  coreFieldList: any;
  coreFieldSaveCompare: any;
  coreFieldListSubmit: any;
  ImageUploadURL: any = '';
  imagelist: any;
  dropdownlist: any=[]=[];
  dropdownlistType: any;
  newdropdownlist: any;

  multipleDropdownList: any;
  newmultipleDropdownList: any;

  checkBoxList: any;
  newcheckBoxList: any;
 
  chkStatusArry: any;
  imageSrc: string;
  FileName: any;
  FileExtention: any;
  Base64String: any;
  @Output() closeAdd = new EventEmitter<boolean>();
  tempValue: any;
  TypeList: any = [];
  step = 0;


  AllTypeList: any = [];
  selectedTypeList: any;

  fieldsList: any[] = [];
  selectedTypefieldsList: any[] = [];
  getSubFolderFieldsListResponseHolder: any;
 
  getSubFolderFieldsModel = {
    databaseID: 0,
    userID: "",
    folderID: 0,
    organizationID: 0,
    subFolderID: 0,
    fieldID: 0
  };
 
  CityModel = {
    Name: '',
    databaseID: 0,
    userID:''
  };
  ZipModel = {
    ZipCodeValue: '',
    databaseID: 0,
    userID:''
  };

  
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  typeId: number = 0;
  TypeListForDropDown: any = [];


  //visible = true;
  //selectable = true;
  //removable = true;
  //separatorKeysCodes: number[] = [ENTER, COMMA];
  
  cityOption: string[]=[];
  filteredOptions: Observable<string[]>;
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;

  //tags: string[] = [];
  //allTags: string[] = [];

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  //@ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('Input') InputFile: ElementRef;
  //@ViewChild('repeatTaskFieldId') repeatTaskFieldId: ElementRef;
  //@ViewChild('repeatTaskFieldId') selectElement: MatSelect;
  
  arryaControlNameIdpare: any=[];
  tagvalues: string;
  zipOption: any[];
  stateList: any[];
  selectedFieldValue: any=10433 ;
  permissionAsssign: any[] = [];
  folderListPermission: any[] = [];
 // folderList: any[] = [];
  coreUserList: any;
 // transactionID: number;
  isTypeChanged: boolean=false;
  TypeIdDrp:number=0;
  arrayControlNameSubfolderID: any=[];
  dynamicArrayEdit: any;
  dynamicArrayTemp: any;
  dynamicArrayEditTemp: any;
  dynamicArrayPhoneTemp: any;
  dynamicArrayAddressTemp: any;
  dynamicArrayWebsiteTemp: any;
  emptyArrya: any=[];
  taskListName:string="";

  public showSpinners = true;
  currentFormLinkFormName: any='';
  @Input() mainModulename: string;
  @Input() SingleTaskArchived:boolean;

  repeatTaskEmail:string="";
  EmailTemplate:string="";
  showRepeatTaskEmail:boolean=false;
  showRepeatTaskForCCC:boolean=false;
  addByEmail:string="";
  addByName:string="";
     
  
  
    getdropdownlist(fieldName) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      return _newdropdownlist[0]!=undefined ? _newdropdownlist[0].value :"";
    }
  
    getMuldropdownlist(fieldName) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      return _newMuldropdownlist[0]!=undefined ? _newMuldropdownlist[0].value :"";
    }
  
    
    getCheckBoxlist(fieldName) {
      var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
      return _newcheckBoxlist[0]!=undefined ? _newcheckBoxlist[0].value :"";
    }
  
    OnChange($event: any, chk: any, fieldId: any) {   
      let ckhchecked = [];
      if (!this.chkStatusArry) {
        this.chkStatusArry = [];
      }
      if ($event.checked) {
        this.chkStatusArry.push({
          ckh: chk,
          fieldId: fieldId,
        });
      } else {
        if(this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
          this.chkStatusArry = this.chkStatusArry.filter(
            (item) =>
              item.ckh != chk
          );
        }
      }
    }
  
    isChecked(fieldName, chk) {
      var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
      if (_newcheckBoxlist[0].selectedCHK != '') {
        return _newcheckBoxlist[0].selectedCHK.toString().includes(chk);
      } else {
        return false;
      }
    }

    getddlSelectedVal(fieldName) {
      if (this.dropdownlist) {
        var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
        if (_newdropdownlist[0] && _newdropdownlist[0].selectedVal != '' && _newdropdownlist[0].selectedVal != undefined) {
          return _newdropdownlist[0].selectedVal;
        } else {
          return '';
        }
      }
    }

    getMultiddlSelectedVal(fieldName) {
      if (this.multipleDropdownList) {
        var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
        if (_newMuldropdownlist[0] && _newMuldropdownlist[0].selectedVal != '' && _newMuldropdownlist[0].selectedVal!= undefined) {
          if(fieldName!="Tags"){         
            return _newMuldropdownlist[0].selectedVal.split(',');
          }else{
            return _newMuldropdownlist[0].selectedVal;
          }
        } else {
          return '';
        }
      }
    }

    add(event: MatChipInputEvent): void {
      const input = event.input;
      const value = event.value.toLowerCase();
      this.allTags;
      var check=[];
      check= this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
      if(check.length>0){
       this.fruitCtrl.setValue(null);
       return;
      }   
      // Add our tag
      if ((value || '').trim()) {
        var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
        const index = arrToUp.indexOf(value.trim());
        if (index >= 0) {
        }
        else {
          this.tags.push(event.value.trim());
        }
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
  
      this.fruitCtrl.setValue(null);
    }
  
    remove(fruit: string): void {
      const index = this.tags.indexOf(fruit);
  
      if (index >= 0) {
        this.tags.splice(index, 1);
      }
    }
  
    selected(event: MatAutocompleteSelectedEvent): void {
      this.tags =  this.tags.map(function (el) {
        return el.trim();
      });
      const index = this.tags.indexOf(event.option.viewValue);
  
      if (index >= 0) {
        this.fruitInput.nativeElement.value = '';
        //this.fruits.splice(index, 1);
      }
      else {
        this.tags.push(event.option.viewValue);
        this.fruitInput.nativeElement.value = '';
        this.fruitCtrl.setValue(null);
      }
    }
    
    getCoreUserDetailsOnTypeChange(event:any,fieldName:any){  
      this.transactionID;
      this.isTypeChanged=true;
      this.TypeIdDrp = parseInt(event.value);   
      this.arryaControlNameIdpare=[]
      this.arrayControlNameSubfolderID=[];
      this.GetFileFields();  
   }

   onDocumentTypeChange(event:any){     
    this.isTypeChanged=true;
    this.TypeIdDrp = parseInt(event.value);   
    this.arryaControlNameIdpare=[]
    this.arrayControlNameSubfolderID=[];
    this.GetFileFields();  
 }

   transactionIDForTask:number=0;
   typeIdForTask:number=1;
   NameForTask:string="";
   EmailForTask:string="";
   ImageForTask:string="";
   documentTypeList:any=[]=[];

   GetFileFields() {      
    var reqModel={
      fileID: this.fileManagerItemID,
      documentTypeID:this.TypeIdDrp,
      userID : this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),          
      officeID:this.myOfficeID,
    }   
    this.loaderService.show();
    this.fileManagerService.getFileFields(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {

          this.documentTypeList= response.data.docTypes;
          this.coreUserList = response.data.docTypeFields;       
          this.coreFieldSaveCompare = response.data.docTypeFields;
          this.coreFieldList = response.data.docTypeFields;

          if(this.coreUserList.length>0){
            this.coreUserList.forEach(e => {
              e.fieldValue = e.value
            });
          }
          //this.TypeListForDropDown =response.data.docTypes;
          //this.TypeListForDropDown.splice(0,0,{folderName: "Select",isChecked: false,subFolderID: 0});
         
          // var TypeData =  this.coreUserList.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type'); 
                     
          // if(TypeData!=undefined && TypeData!='' && TypeData!=null && isFromDDlType==false)
          // {
          //   this.TypeIdDrp=Number(TypeData[0].fieldValue);
          // }
          // var taglist;
          // taglist = this.coreUserList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
          // if (taglist.length > 0 && taglist !=undefined) {
          //   this.tags = [];
          //   if(taglist[0].fieldValue != ""){
          //     var str = taglist[0].fieldValue;
          //     var selectedValues = str.replace(/^,|,$/g, '');
          //     this.tags = selectedValues.split(',');             
          //   }
          //   else {
          //     this.tags=[];
          //   }           
          // }
          // else {
          //   this.tags=[];
          // }   
  
          // var NewList;
          // NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
          // var type;
          // type = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');
         
          // NewList.splice(1, 0, type[0]);
          // this.coreUserList = NewList;
         
          //Change name for dynamic elements
          //Group them one beneath othe for multi name array
          // let multiNameArray = [];
          // let ArrayWithGroupedElement = [];
          // this.coreUserList = this.coreUserList.filter((s) => s.availableOn != 2); 
          // this.coreUserList = this.coreUserList.filter((s) => s.rolePermission != 2);
                   
          // this.coreUserList.forEach((formControl) => {
          //   let count = multiNameArray.filter((x) => x.fieldID == formControl.fieldID).length;
          //   if (count == 0) {
          //       multiNameArray.push(formControl);
          //        //  Save control name and ID
          //       this.arryaControlNameIdpare.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subFolderID:formControl.subFolderID
          //       });
          //       this.arrayControlNameSubfolderID.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subfolderID:formControl.subFolderID
          //       });
  
          //       if(formControl.fieldName.includes('Address'))
          //       {
          //        formControl.address.forEach((ac,i) =>  {
          //         if(i>0)
          //          this.arryaControlNameIdpare.push({
          //            name:this.getAddressTypeFieldName(ac.childFieldType),
          //            id:ac.id,
          //            subFolderID:ac.subFolderID
          //          });
          //          this.arrayControlNameSubfolderID.push({
          //           name:this.getAddressTypeFieldName(ac.childFieldType),
          //           id:ac.id,
          //           subfolderID:formControl.subFolderID
          //         });
          //        });
          //       }        
          //   }
          //  else if (count > 0) {
          //     multiNameArray.push(formControl);
          //     formControl.fieldName = formControl.fieldName + count;
          //        //  Save control name and ID
          //       this.arryaControlNameIdpare.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subFolderID:formControl.subFolderID
          //       });
          //       this.arrayControlNameSubfolderID.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subfolderID:formControl.subFolderID
          //       });
          //       if(formControl.fieldName.includes('Address')){
          //        formControl.address.forEach((ac,i) => {
          //          if(i>0)
          //          this.arryaControlNameIdpare.push({
          //            name:this.getAddressTypeFieldName(ac.childFieldType)+count,
          //            id:ac.id,
          //            subFolderID:ac.subFolderID
          //          });
          //          this.arrayControlNameSubfolderID.push({
          //           name:this.getAddressTypeFieldName(ac.childFieldType),
          //           id:ac.id,
          //           subfolderID:formControl.subFolderID
          //         });
          //        });
          //       }           
          //   }
          // });
  
  
          // this.coreUserList.forEach((formControl) => {
          //   let count = ArrayWithGroupedElement.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldName.length > 0).length;
          //   let elements = this.coreUserList.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldName.length > 0);
          //   if (count == 0 && elements.length > 0) {
          //     if (elements[0].fieldName.includes('Address')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Address');
          //       this.dynamicArrayAddressTemp = this.dynamicArrayEdit;
          //     }
  
          //     if (elements[0].fieldName.includes('Email')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Email');
          //       this.dynamicArrayTemp = this.dynamicArrayEdit;
          //     }
  
          //     if (elements[0].fieldName.includes('Phone')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Phone');
          //       this.dynamicArrayPhoneTemp = this.dynamicArrayEdit;
          //     }
  
          //     if (elements[0].fieldName.includes('Website')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Website');
          //       this.dynamicArrayWebsiteTemp = this.dynamicArrayEdit;
          //     }
              
          //     ArrayWithGroupedElement.push(elements[0]);             
          //   }
          //   if (count == 0 && elements.length == 0)
          //     ArrayWithGroupedElement.push(formControl);
          // });
          
          // this.coreUserList = ArrayWithGroupedElement;
        
           const Fields = {};
           this.coreUserList.forEach((formControl) => {
            // if (formControl.fieldName == 'Name') {
            //   //this.transactionUserName = this.taskDetailList.title;            
            // }
            // if (formControl.fieldName == 'Type') {           
            //   let type=this.TypeListForDropDown.find(x=>x.subFolderID==formControl.fieldValue);
            //   this.transactionUserRole = (type!=null ||type!=undefined)?type.folderName:""
            // }
            Fields[formControl.fieldName] = new FormControl('');
            // if (formControl.fieldName.length > 0) {
            //   Fields[formControl.fieldName + 'option'] = new FormControl('');

            //   let plcHolder = formControl.fieldName.find((x) => x.fieldID == formControl.fieldID);
            //   formControl.placeholderVal=plcHolder != null ? plcHolder.fieldName : formControl.fieldName;

            //  // let plcHolder = formControl.fieldNames.find((x) => x.fieldNameID == formControl.fieldNameID);
            //  // formControl.placeholderVal=plcHolder != null ? plcHolder.fieldName : formControl.fieldNames[0];
            // }           
          });
          // this.ImagePathURL = (response.data.imageUrl==null || response.data.imageUrl==undefined || response.data.imageUrl=='')?'':response.data.imageUrl;
          
          // Fields['City'] = new FormControl();
          // Fields['State'] = new FormControl();
          // Fields['ZipCode'] = new FormControl();
          // Fields['Country'] = new FormControl();
          
            // address computaion array for computation
        //  this.addressFormGroup.push('Address');
        //  this.addressFormGroup.push('City');
        //  this.addressFormGroup.push('State');
        //  this.addressFormGroup.push('ZipCode');
        //  this.addressFormGroup.push('Country');
        
        //   Fields['fruitCtrl'] = this.fruitCtrl; 
           this.myFormGroup = new FormGroup(Fields);          
  
           this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
           this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
           this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');
             
           var data = [];

           data=this.coreUserList.filter((s) => s.fieldID ==0);
 
           if (data.length > 0) {
             for (var i = 0, len = data.length; i < len; ++i) {
               var DrpData = [];
               DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
               if(DrpData.length>0){
                 for (var v = 0, char = DrpData.length; v < char; ++v) {
                   this.dropdownlist.push(DrpData[v]);
                 }
               }
              
               var MultiData=[];
               MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
               if(MultiData.length>0){
                 for (var v = 0, char = MultiData.length; v < char; ++v) {
                   this.multipleDropdownList.push(MultiData[v]);
                 }
               }
               
               var CheckboxData=[];
               CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
               if(CheckboxData.length>0){
                 for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                   this.checkBoxList.push(CheckboxData[v]);
                 }
               }             
             }
           }               
 
             if (this.dropdownlist.length > 0) {
               var fieldListdrp = [];
               var value;
               for (let i = 0; i < this.dropdownlist.length; i++) {
                 var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
                 value = drpValue.split(',');
                 var FieldsDrp = {
                   FieldValue: this.dropdownlist[i].fieldName,
                   value: value,
                 };
                 fieldListdrp.push(FieldsDrp);
               }
               this.dropdownlist = fieldListdrp;
             }
 
             if (this.multipleDropdownList.length > 0) {
               var fieldmulListdrp = [];
               var value;
               for (let i = 0; i < this.multipleDropdownList.length; i++) {
                 var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                 value = muldrpValue.split(',');
                 var FieldsMulDrp = {
                   FieldValue: this.multipleDropdownList[i].fieldName,
                   value: value,
                 };
                 fieldmulListdrp.push(FieldsMulDrp);
               }
               this.multipleDropdownList = fieldmulListdrp;
             }
 
             if (this.checkBoxList.length > 0) {
               var fieldcheckbox = [];
               var value;
               for (let i = 0; i < this.checkBoxList.length; i++) {
                 var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                 value = checkboxValue.split(',');
                 var FieldsCheckbox = {
                   FieldValue: this.checkBoxList[i].fieldName,
                   value: value,
                 };
                 fieldcheckbox.push(FieldsCheckbox);
               }
               this.checkBoxList = fieldcheckbox;
             }   

           // Modified array containing group ends 
           this.fillCheckBoxList();
           this.prepareCheckboxListForUI();

           this.fillDropDown();
           this.prepareDropDownForUI();

           this.fillMultiDropDown();
           this.prepareMultiDropDownForUI();      

          // //#region geting core filds
          // var reqModel={
          //   fileID: this.fileManagerItemID,
          //   documentTypeID:this.TypeIdDrp,
          //   userID : this.currentUser.UID,
          //   organizationID: Number(this.organizationId),
          //   databaseID: Number(this.databaseId),          
          //   officeID:this.myOfficeID,
          // }           
          // this.fileManagerService.getFileFields(reqModel).subscribe((response) => {
          //  var tempArryacoreFieldList=response.data.docTypeFields.filter((m) => m.fieldID == 0);
          //   response.data.docTypeFields = response.data.docTypeFields.filter((m) => m.fieldID > 0);
          //   this.coreFieldList = response.data.docTypeFields;
          //    // Modified array containing group starts
          //     // tempArryacoreFieldList.forEach(element => {
          //     //   if(element.data.length>1) {
          //     //     var indexArray=[];                  
          //     //     element.data.forEach(elementin => {
          //     //       if(elementin.fieldID>0){
          //     //         let grpele=this.coreUserList.find(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
          //     //         elementin.fieldValue=grpele!=undefined?grpele.fieldValue:"";
          //     //         elementin.id=grpele!=undefined?grpele.id:0;
          //     //         elementin.isRequired=grpele!=undefined?grpele.isRequired:false;
          //     //         if(elementin.fieldNames.length>0){
          //     //         elementin.fieldNameID=grpele.fieldNameID;
          //     //         elementin.placeholderVal=grpele.placeholderVal;                       
          //     //         }
          //     //         this.coreFieldList.push(elementin);
          //     //         if (!this.myFormGroup.contains(elementin.fieldName)){
          //     //           this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
          //     //         }
          //     //         var index = this.coreUserList.findIndex(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
          //     //         indexArray.push(index);
          //     //       }
          //     //     });                 
                 
          //     //     this.coreUserList = this.coreUserList.filter(function(value, index) { 
          //     //       return indexArray.indexOf(index) == -1; 
          //     //     }) ;
          //     //     this.coreUserList.splice(indexArray[0],0,element);                  
          //     //   }
          //     // });            
            
          //     // ArrayWithGroupedElement.forEach(element => {
          //     //   if(element.fieldName=="Address"){
          //     //     if(element.address.length>0){
          //     //       if(element.address.find(m=>m.childFieldType==3)!=undefined)
          //     //         this.cityValue=element.address.find(m=>m.childFieldType==3).fieldValue;
          //     //         else
          //     //         this.cityValue="";
          //     //       if(element.address.find(m=>m.childFieldType==2)!=undefined)
          //     //         this.stateValue=element.address.find(m=>m.childFieldType==2).fieldValue;
          //     //         else
          //     //         this.stateValue="";
          //     //       if(element.address.find(m=>m.childFieldType==4)!=undefined)
          //     //         this.zipValue=element.address.find(m=>m.childFieldType==4).fieldValue;
          //     //         else
          //     //         this.zipValue="";
          //     //     }
          //     //   }
          //     // });
              
          //     this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
          //     this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
          //     this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');
                
          //     var data = [];
  
          //     data=this.coreUserList.filter((s) => s.fieldID ==0);
    
          //     if (data.length > 0) {
          //       for (var i = 0, len = data.length; i < len; ++i) {
          //         var DrpData = [];
          //         DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
          //         if(DrpData.length>0){
          //           for (var v = 0, char = DrpData.length; v < char; ++v) {
          //             this.dropdownlist.push(DrpData[v]);
          //           }
          //         }
                 
          //         var MultiData=[];
          //         MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
          //         if(MultiData.length>0){
          //           for (var v = 0, char = MultiData.length; v < char; ++v) {
          //             this.multipleDropdownList.push(MultiData[v]);
          //           }
          //         }
                  
          //         var CheckboxData=[];
          //         CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
          //         if(CheckboxData.length>0){
          //           for (var v = 0, char = CheckboxData.length; v < char; ++v) {
          //             this.checkBoxList.push(CheckboxData[v]);
          //           }
          //         }             
          //       }
          //     }               
    
          //       if (this.dropdownlist.length > 0) {
          //         var fieldListdrp = [];
          //         var value;
          //         for (let i = 0; i < this.dropdownlist.length; i++) {
          //           var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
          //           value = drpValue.split(',');
          //           var FieldsDrp = {
          //             FieldValue: this.dropdownlist[i].fieldName,
          //             value: value,
          //           };
          //           fieldListdrp.push(FieldsDrp);
          //         }
          //         this.dropdownlist = fieldListdrp;
          //       }
    
          //       if (this.multipleDropdownList.length > 0) {
          //         var fieldmulListdrp = [];
          //         var value;
          //         for (let i = 0; i < this.multipleDropdownList.length; i++) {
          //           var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
          //           value = muldrpValue.split(',');
          //           var FieldsMulDrp = {
          //             FieldValue: this.multipleDropdownList[i].fieldName,
          //             value: value,
          //           };
          //           fieldmulListdrp.push(FieldsMulDrp);
          //         }
          //         this.multipleDropdownList = fieldmulListdrp;
          //       }
    
          //       if (this.checkBoxList.length > 0) {
          //         var fieldcheckbox = [];
          //         var value;
          //         for (let i = 0; i < this.checkBoxList.length; i++) {
          //           var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
          //           value = checkboxValue.split(',');
          //           var FieldsCheckbox = {
          //             FieldValue: this.checkBoxList[i].fieldName,
          //             value: value,
          //           };
          //           fieldcheckbox.push(FieldsCheckbox);
          //         }
          //         this.checkBoxList = fieldcheckbox;
          //       }   
  
          //     // Modified array containing group ends 
          //     this.fillCheckBoxList();
          //     this.prepareCheckboxListForUI();
  
          //     this.fillDropDown();
          //     this.prepareDropDownForUI();
  
          //     this.fillMultiDropDown();
          //     this.prepareMultiDropDownForUI();              
          //   });
         
          // this.dynamicArray=[];
          // this.dynamicArrayAddress=[];
          // this.dynamicArrayPhone=[];
          // this.dynamicArrayWebsite=[];
          // if(this.dynamicArrayTemp!=undefined){
          //   this.dynamicArrayTemp.forEach((e,i) => {
          //     this.appendEle(e, 1,i+1);
          //   });
          // }
          // if(this.dynamicArrayAddressTemp!=undefined){
          //   this.dynamicArrayAddressTemp.forEach((e,i) => {
          //     this.appendEle(e, 2,i+1);
          //   });
          // }
          
          // if(this.dynamicArrayPhoneTemp!=undefined){
          //   this.dynamicArrayPhoneTemp.forEach((e,i) => {
          //     this.appendEle(e, 3,i+1);
          //   });
          // }
          
          // if (this.dynamicArrayWebsiteTemp != undefined)
          //   this.dynamicArrayWebsiteTemp.forEach((e,i) => {
          //     this.appendEle(e, 4,i+1);
          //   });
            this.loaderService.hide();
          // if(this.isTypeChanged){
            // this.myFormGroup.get('Type').markAsDirty();
          //   this.isTypeChanged=false;
          // }
        } else {
          this.coreUserList = [];
          this.loaderService.hide();
        }
      }else{
        this.coreUserList = [];
        this.loaderService.hide();
      }
    });
  }

  fillCheckBoxList() {
    if (this.coreFieldList) {
      this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');      
    }
  }

  appendEle(field: any, type: any,index:any) {
    this.myFormGroup.addControl(field.fieldName, this.formBuilder.control(''));
    this.myFormGroup.addControl(
      field.fieldName + 'option',
      this.formBuilder.control('')
    );
    let plcHolder = field.fieldNames.find((x) => x.fieldNameID == field.fieldNameID);
  
    let addressRefactor:any=[];
    if(field.address!=undefined && field.address.length>0)
    {
    addressRefactor.push(field.address.find(x=>x.childFieldType==0));
    addressRefactor.push(field.address.find(x=>x.childFieldType==3));
    addressRefactor.push(field.address.find(x=>x.childFieldType==2));
    addressRefactor.push(field.address.find(x=>x.childFieldType==4));
    }
  
  // addressRefactor.splice(2,0,field.address.find(x=>x.childFieldType==3));
    let uiField = {
      fieldID: field.fieldID,
      fieldName: field.fieldName,
      fieldNameID: field.fieldNameID,
      fieldNames: field.fieldNames,
      fieldTypeID: field.fieldTypeID,
      fieldTypeName: field.fieldTypeName,
      fieldValue: field.fieldValue,
      transactionID: field.transactionID,
      placeholderVal: plcHolder != null ? plcHolder.fieldName : '',
      address:addressRefactor,
      isPrimary:field.isPrimary
    };
   
    
    //1 Email ,2 Address,3 Phone,4 website
    if(type==2){
      this.myFormGroup.addControl('City' + index,this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + index,this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + index,this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + index,this.formBuilder.control(''));   
  
      // address array for computation
      this.addressFormGroup.push('Address'+ index);
      this.addressFormGroup.push('City'+ index);
      this.addressFormGroup.push('State'+ index);
      this.addressFormGroup.push('ZipCode'+ index);
      this.addressFormGroup.push('Country'+ index);
    }
    if (type == 1) this.dynamicArray.push(uiField);
    if (type == 2) this.dynamicArrayAddress.push(uiField);
    if (type == 3) this.dynamicArrayPhone.push(uiField);
    if (type == 4) this.dynamicArrayWebsite.push(uiField);    
  }

  prepareCheckboxListForUI() {
    if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
      var fieldcheckbox = [];
      var value;
      if (!this.chkStatusArry) {
        this.chkStatusArry = [];
      }
      for (let i = 0; i < this.checkBoxList.length; i++) {       
        var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
        value = checkboxValue.split(','); 
        var selectedVal;
        let chk=this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);
      
        if(chk.length>0){
          selectedVal=chk[0].fieldValue;
        }
         else{
         selectedVal=this.checkBoxList[i].fieldValue
        }  
  
        if(selectedVal==undefined || selectedVal==null){
          selectedVal="";
        }
        // if(chk.length==0){
        //   selectedVal="";
        // } 
        
        var FieldsCheckbox = {
          FieldValue: this.checkBoxList[i].fieldName,
          value: value,
          selectedCHK: selectedVal//this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
        };
  
        fieldcheckbox.push(FieldsCheckbox);
  
        let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
        for (let n = 0; n < selectedCHKArray.length; n++) {
          this.chkStatusArry.push({
            ckh: selectedCHKArray[n],
            fieldId: this.checkBoxList[i].fieldID,
          });
        }
      }
      this.checkBoxList = fieldcheckbox;
    }
  }
  
  fillMultiDropDown() {
    this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
  }
  
  prepareMultiDropDownForUI() {
    if (this.multipleDropdownList.length > 0) {
      var fieldmulListdrp = [];
      var value;
      for (let i = 0; i < this.multipleDropdownList.length; i++) {
        var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
        value = muldrpValue.split(',');
        var selectedVal;
        let drp=this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID);
        if(drp.length>0){
          selectedVal=drp[0].fieldValue;
        }
        else{
         selectedVal=this.multipleDropdownList[i].fieldValue
       }
  
       if(selectedVal==undefined || selectedVal==null){
        selectedVal="";
       }
      //  if(drp.length==0){
      //   selectedVal="";
      //  } 
  
        var FieldsMulDrp = {
          FieldValue: this.multipleDropdownList[i].fieldName,
          value: value,
          selectedVal:selectedVal// this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID).map((k) => k.fieldValue).toString().split(','),
        };
        fieldmulListdrp.push(FieldsMulDrp);
      }
      this.multipleDropdownList = fieldmulListdrp;
    }
  }
  
  fillDropDown() {
    this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown');
    this.dropdownlist.forEach(element => {
      if (element.fieldName == 'Type') { element.defaultValue = this.TypeList }
    });
  }
  
  prepareDropDownForUI() {
    if (this.dropdownlist.length > 0) {
      var fieldListdrp = [];
      var value;
      for (let i = 0; i < this.dropdownlist.length; i++) {
  
        if(this.dropdownlist[i].defaultValue.length > 0)  {
          var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
          value = drpValue.split(',');
          var selectedVal;
         let drp=this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID);
         if(drp.length>0){
           selectedVal=drp[0].fieldValue;
         }
         else{
          selectedVal=this.dropdownlist[i].fieldValue
        } 
  
        if(selectedVal==undefined || selectedVal==null){
          selectedVal="";
        }
        // if(drp.length==0){
        //   selectedVal="";
        //  }
         
         var FieldsDrp = {
          FieldValue: this.dropdownlist[i].fieldName,
          value: value,
          selectedVal: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID).map((k) => k.fieldValue),
        };
        fieldListdrp.push(FieldsDrp);
       }
      }
      this.dropdownlist = fieldListdrp;      
    }
  }

  numberOnlyForSch(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addressValueField: any=Object;
  cityValueField: any=Object; 
  stateValueField: any=Object; 
  zipValueField: any=Object; 

  addMoreEditField(fieldName: any) {
    if (fieldName.includes('Email')) {
      fieldName = 'Email';
      let length = this.dynamicArray.length;
      length = this.getCurrentIndex('Email');
      this.myFormGroup.addControl( fieldName + length,this.formBuilder.control(''));
      this.myFormGroup.addControl( fieldName + length + 'option',this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
          var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArray.push(field);
      }
    }
    // Phone
    if (fieldName.includes('Phone')) {
      fieldName = 'Phone';
      let length = this.dynamicArrayPhone.length;
      length = this.getCurrentIndex('Phone');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option',this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
          var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayPhone.push(field);
      }
    }
    //Address
    if (fieldName.includes('Address')) {
      fieldName = 'Address';
      if (this.dynamicArrayAddress == undefined) this.dynamicArrayAddress = [];
      let length = this.dynamicArrayAddress.length;
      length = this.getCurrentIndex('Address');

      this.myFormGroup.addControl(fieldName + length,this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      this.addressValueField[fieldName + length]='';
      this.cityValueField['City' + length]='';
      this.stateValueField['State' + length]='';
      this.zipValueField['ZipCode' + length]=''
      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          ctrl = formControl;
        }
      });

      //
      this.myFormGroup.addControl('City' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length,this.formBuilder.control(''));   

      // address array for computation
      this.addressFormGroup.push('Address'+ length);
      this.addressFormGroup.push('City'+ length);
      this.addressFormGroup.push('State'+ length);
      this.addressFormGroup.push('ZipCode'+ length);
      this.addressFormGroup.push('Country'+ length);
     
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var fieldAddress = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
          address:this.emptyArrya
        };
        this.dynamicArrayAddress.push(fieldAddress);
      }
    }
    //Website
    if (fieldName.includes('WebSite')) {
      fieldName = 'WebSite';
      let length = this.dynamicArrayWebsite.length;
      length = this.getCurrentIndex('WebSite');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option',this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
         var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayWebsite.push(field);
      }
    }
  }

  addMore(fieldName: any) {
    if (fieldName.includes('Email')) {
      fieldName = 'Email';
      let length = this.dynamicArray.length;
      length = this.getCurrentIndex('Email');
      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArray.push(field);
      }
    }
    // Phone
    if (fieldName.includes('Phone')) {
      fieldName = 'Phone';
      let length = this.dynamicArrayPhone.length;
      length = this.getCurrentIndex('Phone');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayPhone.push(field);
      }
    }
    //Address
    if (fieldName.includes('Address')) {
      fieldName = 'Address';
      if (this.dynamicArrayAddress == undefined) this.dynamicArrayAddress = [];
      let length = this.dynamicArrayAddress.length;
      length = this.getCurrentIndex('Address');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      this.addressValueField[fieldName + length] = '';
      this.cityValueField['City' + length] = '';
      this.stateValueField['State' + length] = '';
      this.zipValueField['ZipCode' + length] = ''
      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          ctrl = formControl;
        }
      });

      //
      this.myFormGroup.addControl('City' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length, this.formBuilder.control(''));

      // address array for computation
      this.addressFormGroup.push('Address' + length);
      this.addressFormGroup.push('City' + length);
      this.addressFormGroup.push('State' + length);
      this.addressFormGroup.push('ZipCode' + length);
      this.addressFormGroup.push('Country' + length);

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var fieldAddress = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
          address: this.emptyArrya
        };
        this.dynamicArrayAddress.push(fieldAddress);
      }
    }
    //Website
    if (fieldName.includes('WebSite')) {
      fieldName = 'WebSite';
      let length = this.dynamicArrayWebsite.length;
      length = this.getCurrentIndex('WebSite');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayWebsite.push(field);
      }
    }
  }

  getCurrentIndex(fieldName: any) {
    for (let i = 1; i < 10; i++) {
      if (!this.myFormGroup.contains(fieldName + i)) {
        length = i;
        return i;
      }
    }
  }

  showMap = false;
  urlSafe: SafeResourceUrl;

  showLocationOnMap(add : string){
    const zipCode = this.myFormGroup.get('ZipCode').value;
    const city = this.myFormGroup.get('City').value
    const state = this.myFormGroup.get('State').value
    // let url = `https://maps.google.com/maps?q=${add}${city}${state}${zipCode}=&output=embed`;
    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    // this.showMap = !this.showMap;
   }

   clearDate(field) {
    return field.fieldValue="";    
  }

  clearPlaceholder(event: any) {
    event.source.placeholder = '';
  }

  searchZip(zip :any){
    this.ZipModel.databaseID = Number(this.databaseId);
    this.ZipModel.ZipCodeValue = zip;
    this.ZipModel.userID = this.currentUser.UID;
    this.fileManagerService.searchTransZip(this.ZipModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {     
          this.zipOption=[];
          response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }

  searchCity(name :any){ 
    this.CityModel.databaseID = Number(this.databaseId);
    this.CityModel.Name = name;
    this.CityModel.userID = this.currentUser.UID;
    this.fileManagerService.searchTransCities(this.CityModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {          
          this.cityOption=[];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }


  onSelectFile(fileInput: any) {
    //this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var test = filename.split('.');
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
  }

  // Used to make Collapsible Panel for group fields
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }


  // get Tag List
  getAllTagsList() {
    var obj={
      databaseID : Number(this.databaseId),
      organizationID : Number(this.organizationId),
      tagName : '',
      PageSize : 0,
      officeID : this.myOfficeID,
      officeIDList: this.OfficeIDList
    }    
    this.fileManagerService.getAllTagsList(obj).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagNames;         
        }
        else {
  
        }
      }
    });
  }

  getStateDropdownList(countryId:any) {
    if (countryId!=undefined) {
      this.fileManagerService.getStateList(countryId).subscribe(response => {
          if (response!=undefined) {
            if (response.status == this.statusConst.statusSuccess) {
              this.stateList = [];
              if(countryId == 231 || countryId == 38){              
                response.data  =  response.data.filter((x) => x.abbreviation != null);
                response.data.forEach(e => {
                  this.stateList.push(e.abbreviation);
                });
              }else{
                response.data.forEach(e => {
                  this.stateList.push(e.stateName);
                });
              }             
            }
          }
        });
    }
  }


  getAddressTypeFieldName(childFieldType){
    if(childFieldType==3)
    return 'City';
    if(childFieldType==2)
    return 'State';
    if(childFieldType==4)
    return 'ZipCode';
    if(childFieldType==1)
    return 'Country';
   }
   
   spinner:boolean=false;

   onSubmit(formValues, form) {
    if(this.TypeIdDrp==0){
      this.toastr.warning('Please select document type.', '', {
        timeOut: 3000,
      });
      return
    }
    this.spinner=true;
    this.myFormGroup.markAsPristine();

    if (this.myFormGroup.invalid) {
      return;
    }
    if (formValues !== undefined) {
           
      var fieldList = [];

      //Todo Send elements in proper order
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldSaveCompare.find((m) => m.fieldName == key)) {
          this.coreFieldSaveCompare.forEach((s) => {
            if (s.fieldName == key) {
              // if (s.fieldName.length > 0) {
              //   s.fieldNameID =
              //   (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
              //       ? s.fieldNames[0].fieldNameID
              //       : Number(formValues[s.fieldName + 'option']);
              // }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldSaveCompare.find((m) =>
            key.includes(m.fieldName)
          );

          if(key != 'Addressoption' && key != 'Emailoption' && key != 'Phoneoption' && !key.includes('option')){
            if (control != undefined) {
              if (control.fieldName.length > 0) {
                tempList.push({
                  fieldID: Number(control.fieldID),
                  fieldName: key,
                  value: formValues[key],
                   fieldNameID:
                   (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
                       ? control.fieldNames[0].fieldNameID
                     : Number(formValues[key + 'option']),
                });
              }
            }

          }
        }
        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0)
              selectedValues = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues=this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.typeId != undefined) {
                selectedValues = this.typeId.toString();
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];
              }
            }

          }
          // if (tempList[0].fieldTypeName == 'Image') {
          //   if (formValues[key].length == 0) {
          //     selectedValues = '';
          //   } else {
          //     selectedValues = this.ImageUploadURL; 
          //   }
          // }
          let frmctrl= this.arryaControlNameIdpare.find(e => e.name== key);
          var Fields = {
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
                SubFolderID:frmctrl!=undefined? frmctrl.subfolderID:0,
                ChildFields: []
          };

          fieldList.push(Fields);
        }
      }

      // this.imagelist.forEach((element) => {
      //   var FieldsImg = {
      //     FieldID: element.fieldID,
      //     FieldName: element.fieldName,
      //     FieldValue: this.ImageUploadURL,
      //     FieldNameID: null,
      //   };
      //   fieldList.push(FieldsImg);
      // });
     
     
      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      
    //   let indexDefault =fieldList.findIndex(n=>n.FieldName=='Address');
    //   let AddressDefault=fieldList.find(n=>n.FieldName=='Address');
    //   AddressDefault.ChildFields.push({
    //     "id": 0,
    //     "fieldID": AddressDefault.FieldID,
    //     "fieldValue": formValues["City"],
    //     "childFieldType": 3
    //   })
    //   AddressDefault.ChildFields.push({
    //     "id": 0,
    //     "fieldID": AddressDefault.FieldID,
    //     "fieldValue": formValues["State"],
    //     "childFieldType": 2
    //   })
    //   AddressDefault.ChildFields.push({
    //     "id": 0,
    //     "fieldID": AddressDefault.FieldID,
    //     "fieldValue": formValues["ZipCode"],
    //     "childFieldType": 4
    //   })
    //   AddressDefault.ChildFields.push({
    //     "id": 0,
    //     "fieldID": AddressDefault.FieldID,
    //     "fieldValue": formValues["Country"],
    //     "childFieldType": 1
    //   })
    // fieldList = fieldList.filter(function(value, index) { 
    //     return index != indexDefault; 
    // }) ;
    // fieldList.splice(indexDefault,0,AddressDefault);
    /************/   
    /***********/
    

      //
      // this.dynamicArrayAddress.forEach((element,i) => {
      //   i=i+1;
      //   let indexDynamic =fieldList.findIndex(n=>n.FieldName=='Address'+i);
      //   let AddressDynamic=fieldList.find(n=>n.FieldName=='Address'+i);
      //   AddressDynamic.ChildFields.push({
      //     "id": 0,
      //     "fieldID": AddressDynamic.FieldID,
      //     "fieldValue": formValues["City"+i],
      //     "childFieldType": 3
      //   })
      //   AddressDynamic.ChildFields.push({
      //     "id": 0,
      //     "fieldID": AddressDynamic.FieldID,
      //     "fieldValue": formValues["State"+i],
      //     "childFieldType": 2
      //   })
      //   AddressDynamic.ChildFields.push({
      //     "id": 0,
      //     "fieldID": AddressDynamic.FieldID,
      //     "fieldValue": formValues["ZipCode"+i],
      //     "childFieldType": 4
      //   })
      //   AddressDynamic.ChildFields.push({
      //     "id": 0,
      //     "fieldID": AddressDynamic.FieldID,
      //     "fieldValue": formValues["Country"+i],
      //     "childFieldType": 1
      //   })
      // fieldList = fieldList.filter(function(value, index) { 
      //     return index != indexDynamic; 
      // }) ;
      // fieldList.splice(indexDynamic,0,AddressDynamic);

      // });
      //********** */
     // fieldList=[];

      // let myObject;
      // myObject=params;
      // for (let key in myObject) {
      //   if(myObject.hasOwnProperty(key)) {
      //     if(key != "token" && key != "type"){
      //       var obj={
      //         parameterName:key,
      //         value:myObject[key],
      //       }
      //       this.urlParameter.push(obj);
      //     }
      //   }
      // }
       //fieldList

      //  if(this.coreFieldSaveCompare.length>0){
      //   this.coreFieldSaveCompare.forEach((element) => {
      //     var obj = {
      //       fieldID: element.fieldID,
      //       value: element.fieldValue,         
      //   };
      //    fieldList.push(obj);
      //   });       
      // }

      var NewfieldList=[];

       if(fieldList.length>0){
        fieldList.forEach((element) => {
          var obj = {
            fieldID: element.FieldID,
            value: element.FieldValue,         
        };
          NewfieldList.push(obj);
        });       
      }

      

        var reqModel ={       
          documentID : Number(this.fileManagerItemID),
          documentTypeID : Number(this.TypeIdDrp),
          fields : NewfieldList,
          userID : this.currentUser.UID,
          organizationID :  Number(this.organizationId),  
          databaseID : Number(this.databaseId),        
          officeID: this.myOfficeID,        
       }
     
      this.loaderService.show();
      //return;
      this.fileManagerService.updateDocumentTypeFields(reqModel).subscribe((response) => {
      if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.spinner=false;
             // this.myFormGroup.reset();           
              this.GetFileFields();     
              this.toastr.success('Record save successfully.', '', {
                timeOut: 3000,
              });
              this.UpdateDocumentDetails();
              this.tags = [];
            }else{
              this.spinner=false;
              this.loaderService.hide();
            }
          }else{
            this.spinner=false;
            this.loaderService.hide();
          }
        });
    }
  }





}
